import cx from "classnames";

/**
 * Desktop heroes are framed cards, never full-bleed crops. A dedicated desktop image fills a
 * 16:9 card with the text over it; without one the portrait image sits whole beside the text on a
 * tinted card. Phones keep their own layout.
 */
export const desktopHeroCardClassName = (hasDesktopImage: boolean) =>
  cx(
    "desk:mx-auto desk:my-6 desk:w-[calc(100%-4rem)] desk:max-w-6xl desk:overflow-hidden desk:rounded-2xl desk:!bg-none",
    hasDesktopImage
      ? "desk:aspect-[16/9] desk:h-auto desk:max-h-[600px] desk:min-h-0 desk:bg-primary"
      : "desk:grid desk:aspect-auto desk:h-auto desk:min-h-0 desk:grid-cols-[minmax(0,1fr)_minmax(0,22rem)] desk:items-center desk:gap-12 desk:bg-background-two desk:p-12 desk:text-primary",
  );

/** Keeps the text on the light card readable without the photo overlay's shadow. */
export const desktopHeroTextClassName = (hasDesktopImage: boolean) =>
  hasDesktopImage
    ? undefined
    : "desk:[&_*]:![text-shadow:none] desk:[&_button]:!border-brand-color desk:[&_button]:!bg-brand-color desk:[&_button]:!text-white desk:[&_button]:!shadow-none";

export const DesktopHeroImage = ({
  url,
  desktopUrl,
}: {
  url: string;
  desktopUrl: string | null | undefined;
}) =>
  desktopUrl ? (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 hidden bg-cover bg-center desk:block"
        style={{ backgroundImage: `url("${desktopUrl}")` }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 hidden bg-gradient-to-r from-black/60 via-black/20 to-transparent desk:block"
      />
    </>
  ) : (
    <div
      aria-hidden
      className="pointer-events-none hidden aspect-[4/5] w-full rounded-2xl bg-cover bg-center desk:block"
      style={{ backgroundImage: `url("${url}")` }}
    />
  );
